window.addEventListener("DOMContentLoaded", () => {
  let colTitle = document.querySelector(".title__content");
  let AjaxCol = new AjaxCollection();
  AjaxCol.init();
});

class AjaxCollection {
  constructor() { }

  init() {
    let colTitle = document.querySelector(".title__content");
    let sideBarLinks = document.querySelectorAll(".filter-menu a");
    let subcols = document.querySelectorAll(
      ".collections-ajax a"
    );
    let sortby = document.querySelectorAll(".nav-sortby-top a");
    let inputs = document.querySelectorAll(".cc-price-range__input");
    let links = [...sideBarLinks, ...subcols, ...sortby];
    let apply = document.querySelector(".apply-changes span");
    if (!apply) {
      return;
    }
    apply.addEventListener("click", () => {
      document.querySelector(".overlay-mobile-filters").style.display = "none";
    });
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        if (link.classList.contains("filter-clear")) {
        } else {
          if (!link.classList.contains("a-sortby")) {
            link.parentNode.parentNode.classList.toggle("selected");
          }
        }
        if (!link.href.includes("?discount")) {
          if (history.state != null && history.state.parameter) {
            link.href = link.href + `?discount=${history.state.parameter}`;
          }
        }
        if (link.classList.contains("a-sortby")) {
          // Create a URL object from the current URL
          const url = new URL(window.location.href);

          // Get the URLSearchParams object from the URL
          const params = url.searchParams;

        // Check if the parameter exists
          if (params.has("sort_by")) {
          // Update the parameter's value
            params.set("sort_by", link.getAttribute("data-url"));
          } else {
            // Add the parameter with the new value
            params.append("sort_by", link.getAttribute("data-url"));
          }

          // Update the browser's URL without reloading the page
          this.fetchData(url.href);
        } else {
          this.fetchData(link.href);
        }
      });
    });
    inputs.forEach((singleInput) => {
      singleInput.addEventListener('change', debounce((event) => {
        event.preventDefault();
        var queryVals = [];
        let parentElementNode = event.target.parentNode.parentNode;
        parentElementNode.querySelectorAll('input').forEach((inputElement) => {
          if (
            inputElement.value !== '' // has a value
          ) {
            queryVals.push([inputElement.name, encodeURIComponent(inputElement.value)]);
          }
        })
        var newUrl = new URLSearchParams(location.search);
        queryVals.forEach(function (value) {
          newUrl.set(value[0], value[1])
        });
        this.fetchData(location.pathname + '?' + newUrl.toString());
      }, 500))
    })
  }

  fetchData(link) {
    let section = document.querySelector("ul#product-grid");
    let collections = document.querySelector(
      ".collection-hero__inner .collections"
    );
    let loader = document.querySelector(".apply-changes .lds-ring");
    document.querySelector(".apply-changes span").style.opacity = "70%";
    section.classList.add("loading");
    collections.classList.add("loading");
    loader.classList.remove("hidden");
    fetch(link)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const parser = new DOMParser();
        let newDOM = parser.parseFromString(html, "text/html");
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let par = urlParams.get("discount");
        let stateObj = { parameter: par };
        window.history.replaceState(stateObj, null, link);
        loader.classList.add("hidden");
        document.querySelector(".apply-changes span").style.opacity = "100%";
        this.updateCollectionGrid(newDOM, link);
        document.dispatchEvent(
          new CustomEvent("ajaxSearchComplete", {
            bubbles: true,
            detail: {},
          }),
        );
      });
  }

  updateCollectionGrid(newDOM, link) {
    let current = {
      grid: document.querySelector("ul#product-grid"),
      current_filters: document.querySelector(".current-filters"),
      sortby: document.querySelector(".nav-sortby-top"),
      pagination: document.querySelector(".pagination-list-wrapper"),
      title: document.querySelector(".title__content"),
      count: document.querySelector(".showing-products"),
      count_mobile: document.querySelector(
        ".showing-products.only-mobile-view"
      ),
      sideBar: document.querySelector(
        "#sidebar .overlay-mobile-filters .filter-menu"
      ),
      description: document.querySelector(".collection-hero__description"),
      collections: document.querySelector(
        ".collection-hero__inner .collections"
      ),
      collection_list_tabs: document.querySelector(
        ".collection_list_tabs .collections"
      ),
      breadcrumbs: document.querySelector(".breadcrumbs"),
      faq: document.querySelector(".home-sleep-faqs"),
      blog: document.querySelector(".blog-list-collection"),
      reviews: document.querySelector(".carousel-section__wrapper"),
      videos: document.querySelector(".collection-video-section"),
    };
    let news = {
      grid: newDOM.querySelector("ul#product-grid"),
      sortby: newDOM.querySelector(".nav-sortby-top"),
      pagination: newDOM.querySelector(".pagination-list-wrapper"),
      current_filters: newDOM.querySelector(".current-filters"),
      title: newDOM.querySelector(".title__content"),
      count: newDOM.querySelector(".showing-products"),
      count_mobile: newDOM.querySelector(".showing-products.only-mobile-view"),
      sideBar: newDOM.querySelector(
        "#sidebar .overlay-mobile-filters .filter-menu"
      ),
      description: newDOM.querySelector(".collection-hero__description"),
      collections: newDOM.querySelector(".collection-hero__inner .collections"),
      collection_list_tabs: newDOM.querySelector(
        ".collection_list_tabs .collections"
      ),
      breadcrumbs: newDOM.querySelector(".breadcrumbs"),
      faq: newDOM.querySelector(".home-sleep-faqs"),
      blog: newDOM.querySelector(".blog-list-collection"),
      reviews: newDOM.querySelector(".carousel-section__wrapper"),
      videos: newDOM.querySelector(".collection-video-section"),
    };
    if (!news.grid) {
      return;
    }
    current.grid.innerHTML = news.grid.innerHTML;
    current.sortby.innerHTML = news.sortby.innerHTML;
    current.current_filters.innerHTML = news.current_filters.innerHTML;
    let open_filters = [];
    current.sideBar
      .querySelectorAll(".filter-group.pt-filter-mode-replacer")
      .forEach((fg) => {
        if (fg.classList.contains("open")) {
          open_filters.push(fg);
        }
      });
    current.sideBar.innerHTML = news.sideBar.innerHTML;
    current.sideBar
      .querySelectorAll(".filter-group.pt-filter-mode-replacer")
      .forEach((fg) => {
        open_filters.forEach((of) => {
          if (
            of.querySelector(".filter-group__title").innerHTML == fg.querySelector(".filter-group__title").innerHTML
          ) {
            fg.classList.add("open");
          }
        });
      });
    current.count.innerHTML = news.count.innerHTML;
    current.title.innerHTML = news.title.innerHTML;
    current.breadcrumbs.innerHTML = news.breadcrumbs.innerHTML;
    current.collections.innerHTML = news.collections.innerHTML;
    current.collection_list_tabs.innerHTML = news.collection_list_tabs.innerHTML;
    current.description.innerHTML = news.description.innerHTML;
    current.faq.innerHTML = news.faq.innerHTML;
    current.blog.innerHTML = news.blog.innerHTML;
    current.count_mobile.innerHTML = news.count_mobile.innerHTML;
    current.videos.innerHTML = news.videos.innerHTML;
    current.pagination.innerHTML = news.pagination.innerHTML;
    let filter_close_btns = document.querySelectorAll(
      ".current-filters .tag-remove"
    );
    filter_close_btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        document
          .querySelector(`.filter-active-${btn.getAttribute("data-tag")} a`)
          .click();
      });
    });
    if (news.reviews) {
      current.reviews.innerHTML = news.reviews.innerHTML;
    }
    if (
      current.blog.querySelector(
        ".container-block-resources__articulos-post"
      ) == null
    ) {
      current.blog.parentNode.classList.add("hidden");
    } else {
      current.blog.parentNode.classList.remove("hidden");
    }
    if (current.faq.querySelector(".faqs-container h3") == null) {
      current.faq.classList.add("hidden");
    } else {
      current.faq.classList.remove("hidden");
    }
    current.grid.classList.remove("loading");
    current.collections.classList.remove("loading");
    if (link.split("collections/")[1] === "all") {
      document.querySelector(".filter-menu").classList.add("is-all");
      document
        .querySelector(".filter-group.filter-group-all-collections")
        .classList.add("open");
    } else {
      document.querySelector(".filter-menu").classList.remove("is-all");
      /* setTimeOut 500 */
      setTimeout(() => {
        document
          .querySelector(".filter-group.filter-group-all-collections")
          .classList.remove("open");
        document.querySelectorAll(".filter-group")[3].classList.add("open");
      }, 100);
    }
    //current.sideBar.querySelector('.overlay-mobile-filters').style.display = 'flex';
    initToggleFilters();
    this.init();
    this.reloadJS();

    let load_more_btn = document.getElementById("load-more-collections-btn");
    if (load_more_btn) {
      collectionAjax(load_more_btn)
    }
    yotpoWidgetsContainer.initWidgets();
    document
      .querySelector(".collections")
      .scrollIntoView({ behavior: "smooth" });
    document
      .querySelectorAll("#product-grid .grid__item .item")
      .forEach((card) => {
        if (!card.querySelector(".discounted")) {
          applyDiscountCode(card);
        }
      });
    if (typeof updateSelectBox == "function") {
      updateSelectBox();
    }
  }

  reloadJS() {
    preventHyperLinking()
    const collapses = () => {
      const animatedElements = document.querySelectorAll('.fade-in-animation');
      animatedElements.forEach(element => {
        element.classList.add('visible');
      });
      if ($(".js-sp-product-card-key-title").length > 0) {
        $(".js-sp-product-card-key-title").click(function () {
          $(this).toggleClass("is-active");
          $(this).next('.js-sp-product-card-key-list').slideToggle();
        })
      }
      if ($('.js-accordion-list').length > 0) {
        $('.js-accordion-list').each(function () {
          $(this).find('.js-accordion-list-item-body').hide();
        });
        $('.js-accordion-list .js-accordion-list-item-header').click(function (e) {
          let $parentItem = $(this).parent('.js-accordion-list-item');
          let $accordionList = $(this).closest('.js-accordion-list'); // Find the closest accordion container

          $accordionList.find('.js-accordion-list-item')
            .not($parentItem)
            .removeClass('is--active')
            .find('.js-accordion-list-item-body')
            .slideUp();

          if ($parentItem.hasClass('is--active')) {
            $parentItem.removeClass('is--active').find('.js-accordion-list-item-body').slideUp();
          } else {
            $parentItem.addClass('is--active').find('.js-accordion-list-item-body').slideDown();
          }

          return false;
        });
      }
      const $buttons = document.querySelectorAll(".collapse-header");
      if ($buttons.length === 0) return;
      Array.from($buttons).forEach(($button) => {
        $button.addEventListener("click", (e) => {
          e.preventDefault();
          interactCollapses($button);
        });
      });
      function interactCollapses(el) {
        const $buttons = document.querySelectorAll(".collapse-header");
        if (!el.classList.contains("active")) {
          Array.from($buttons).forEach(($button) => {
            $button.classList.remove("active");
            $button.querySelector("span").classList.remove("open");
          });
          el.classList.add("active");
          el.querySelector("span").classList.add("open");
        } else {
          el.classList.remove("active");
          el.querySelector("span").classList.remove("open");
        }
      }
    };
    collapses();
  }

  applyDiscount(card, discountCode) {
    if (discountCode != "") {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get("discount");
      if (paramValue == discountMetafield) {
        if (paramValue && paramValue.includes("-")) {
          let thisCard = card;
          if (!thisCard.hasAttribute("data-nds")) {
            let productPrice = thisCard.querySelector(".price");
            let discount = paramValue.split("-");
            discount = parseInt(discount[1]);
            let originalPrice = parseInt(
              productPrice
                .querySelector(".original__price")
                .innerHTML.replace("$", "")
                .replace(",", "")
                .replace("From", "")
            );
            let newPrice =
              originalPrice - (parseInt(discount) * originalPrice) / 100;
            let promoMsg = thisCard.querySelector(".promo__msg");
            if (thisCard.querySelector(".price__discount")) {
              thisCard
                .querySelector(".price__discount")
                .classList.add("hidden");
            }
            if (thisCard.querySelector(".save-percentage")) {
              thisCard
                .querySelector(".save-percentage")
                .classList.add("hidden");
            }
            thisCard.querySelector(".promo__price").classList.remove("hidden");
            thisCard.querySelector(
              ".promo__price"
            ).innerHTML = `$${newPrice.toLocaleString("en-US")}`;
            productPrice.classList.add("promo__applied");
            promoMsg.classList.add("save-percentage");
            promoMsg.innerHTML = `${discount}%`;
            thisCard.classList.add("discount-code");
          }
        }
      } else {
        let thisCard = card;
        if (!thisCard.hasAttribute("data-nds")) {
          let productPrice = thisCard.querySelector(".price");
          let discount = discountMetafield.split("-");
          discount = parseInt(discount[1]);
          let originalPrice = parseInt(
            productPrice
              .querySelector(".original__price")
              .innerHTML.replace("$", "")
              .replace(",", "")
              .replace("From", "")
          );
          let newPrice =
            originalPrice - (parseInt(discount) * originalPrice) / 100;
          let promoMsg = thisCard.querySelector(".promo__msg");
          if (thisCard.querySelector(".price__discount")) {
            thisCard.querySelector(".price__discount").classList.add("hidden");
          }
          if (thisCard.querySelector(".save-percentage")) {
            thisCard.querySelector(".save-percentage").classList.add("hidden");
          }
          thisCard.querySelector(".promo__price").classList.remove("hidden");
          thisCard.querySelector(
            ".promo__price"
          ).innerHTML = `$${newPrice.toLocaleString("en-US")}`;
          productPrice.classList.add("promo__applied");
          promoMsg.classList.add("save-percentage");
          promoMsg.innerHTML = `${discount}%`;
          thisCard.classList.add("discount-code");
        }
      }
    }
  }



}